import React from 'react';
import { IIconProps } from './type';

const directionRotation = {
  right: 0,
  left: 180,
  bottom: 90,
  top: -90,
};

interface IArrowIconProps extends IIconProps {
  headDirection: 'right' | 'left' | 'bottom' | 'top';
  rotate?: number;
  width?: number;
  height?: number;
}

/** @deprecated use libs/design-system/src/visuals/Icons/ArrowLeft/Right/Top/Bottom.tsx instead */
const Arrow: React.FC<IArrowIconProps> = ({
  width = 8,
  height = 14,
  color = '#000',
  rotate = 0,
  headDirection,
  UNSAFE_className,
  ...props
}) => {
  const rotation = rotate || directionRotation[headDirection] || 0;

  return (
    <svg
      role="presentation"
      xmlns="http://www.w3.org/2000/svg"
      viewBox={`0 0 14 14`}
      width={width}
      height={height}
      className={UNSAFE_className || ''}
      style={{
        transform: `translateY(1px) rotate(${rotation}deg)`,
        // 4px is half of the width of the arrow, allowing it to stay aligned at the left of the box
        // without going out of bounds.
        transformOrigin: '4px',
        transition: 'transform 0.5s',
      }}
      {...props}
    >
      <path
        id="Path"
        d="M0,12.349,4.947,7,0,1.651,1.527,0,8,7,1.527,14Z"
        fill={color}
      />
    </svg>
  );
};

export default Arrow;
